import { defineStore } from "pinia";
import auth from "../service/auth";
import planStore from "./plan";
const useAuth = defineStore("auth", {
  // arrow function recommended for full type inference
  state: () => {
    const token = window.localStorage.getItem("access-token") || "";
    return {
      token: token,
      user: JSON.parse(localStorage.getItem("user")) || {},
      role: "",
      adminDataContainer: JSON.parse(localStorage.getItem("admin-data-container")) || {},
    };
  },
  getters: {
    isAdmin(state) {
      return state.user.role === "admin";
    },
    isLoggedIn(state) {
      return !!state.token;
    },
    adminIsLoggedInAsBasicUser(state) {
      if (state.adminDataContainer.token) return true;
    },
    async isLoggedInAndHaveCreatedPlans(state){
      if(!!state.token){
        const plans = await planStore().getPlans()
        return !!plans.length
      }
      return false;
    }
  },
  actions: {
    async impersonateUser(userId) {
      try {
        //Store admin data for later
        this.adminDataContainer = {
          token: this.token,
          user: this.user,
        };
        localStorage.setItem("admin-data-container", JSON.stringify(this.adminDataContainer));
        //sign in and store basic user where admin data was previously
        const res = await auth.signInAs(userId);
        localStorage.removeItem("access-token");
        localStorage.removeItem("user");
        this.token = res.result.accessToken;
        this.user = res.result.user;
        localStorage.setItem("access-token", this.token);
        localStorage.setItem("user", JSON.stringify(this.user));
        return res.result;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    returnToAdminAccount() {
      //recover admin data and replace basic user's
      let adminData = JSON.parse(localStorage.getItem("admin-data-container"));
      this.token = adminData.token;
      this.user = adminData.user;
      localStorage.removeItem("access-token");
      localStorage.removeItem("user");
      localStorage.setItem("access-token", this.token);
      localStorage.setItem("user", JSON.stringify(this.user));
      localStorage.removeItem("admin-data-container");
      this.adminDataContainer = {};
    },
    async login(credentials) {
      try {
        const res = await auth.signIn(credentials);
        this.token = res.result.accessToken;
        this.user = res.result.user;
        localStorage.setItem("access-token", res.result.accessToken);
        localStorage.setItem("user", JSON.stringify(res.result.user));
        return res.result;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async signup(user) {
      try {
        const res = await auth.signUp(user);
        this.user = res.result.user;
        this.token = res.result.accessToken;
        const token = res.result.accessToken;
        window.localStorage.setItem("access-token", token);
        window.localStorage.setItem("user", JSON.stringify(this.user));
        const plan_store = planStore();
        return res.result;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    logout() {
      localStorage.removeItem("access-token");
      localStorage.removeItem("user");
      this.token = "";
      this.user = {};
      const plan_store = planStore();
      plan_store.currentPlanData = { totalSize: 0, season: null, divisions: [] };
    },
  },
});

export default useAuth;
